import { getProductTypes } from '@api/products';

/**
 * Combo, bundle and kit types are never offered. Picking one without also authoring
 * `combo_product_mappings` rows yields a half-defined combo that downstream BOM and
 * fulfilment reads treat as broken. Lived inside the add-product form; shared now so the
 * drawer offers the same list.
 */
export const COMBO_TYPE_PATTERN = /bundle|combo|kit/i;

/** The brand's own types, combos excluded, for any product-type picker. */
export const loadProductTypeOptions = async (): Promise<string[]> => {
    const types = await getProductTypes().catch(() => [] as string[]);
    return types.filter((t) => t && !COMBO_TYPE_PATTERN.test(t));
};
